import Utils from './utils';
import IframeRenderer from 'libs/iframe-renderer';
export default function(params) {
  var self = this;

  self.defaults = {};

  self.config = _.extend({}, self.defaults, params);

  // Map all properties to 'self'
  ko.mapping.fromJS(params, {}, self);

  self.viewed = ko.observable(false);
  self.isNative = ko.observable(false);
  self.enabled = ko.observable(true);

  self.disabled = ko.computed(function() {
    return !self.enabled();
  });

  self.show = function(media, event) {
    if(self.disabled()) return;

    if(!self.viewed()) {
      var $container = $('#js-video-' + self.id());

      media.renderer = new IframeRenderer({ frame: media.sanitized_alternate_src(), $container: $container.parent(), style: { maxWidth: '100%', maxHeight: '100%' } });
      media.renderer.present();
      $container.remove(); // remove the video container
      self.viewed(true);
    }

    Utils.toggleRowVisibility(event);
  };

  self.updateIframeMedia = function(media) {
    var $container = media.renderer.config.$container;

    media.renderer.destroy();

    media.renderer = new IframeRenderer({ frame: media.sanitized_alternate_src(), $container: $container, style: { maxWidth: '100%', maxHeight: '100%' } });
    media.renderer.present();
    self.saveIframeMedia(media);
  };

  self.saveIframeMedia = function(media) {
    var iframeTag = Kadenze.IframeMediaPlayer.extractUrl(media.sanitized_alternate_src());

    var request = new Kadenze.AjaxRequest({
      url: Kadenze.Routes.lecture_medium_path(media.id()),
      type: 'PATCH',
      data: {
        lecture_medium: {
          lecture_id: self.lecture_id(),
          media_src: Kadenze.IframeMediaPlayer.parseURL(iframeTag),
          alternate_src: iframeTag,
          type: 'IframeMedia',
          media_type: 'iframe'
        }
      },
      loadingIndicator: {
        container: media.renderer.config.$container
      }
    });

    request.done(function() {
      new Kadenze.Notice.success({ message: 'Changes saved successfully' });
    });
  };

  return self;
}


